import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TrivagoService {
  private readonly SERVICE_URL = 'hotels/async/metasearch/trivago';

  constructor(
    private http: HttpClient,
    private readonly cookieService: CookieService,
  ) {}

  public sendTrivagoReference(rateId: string): Observable<any> {
    if (this.cookieService.check('trv_reference')) {
      const body = {
        rate_id: rateId,
        trv_reference: this.cookieService.get('trv_reference'),
      };
      return this.http.post(this.SERVICE_URL, body).pipe(catchError(() => of(false)));
    }
    return of(false);
  }
}
